import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';

import { Form } from '../../shared/form';
import { HttpErrorHandler } from '../../shared/http-error-handler';
import { ChoicesModel } from '../../_models/choices-model';

import { QuotaItem } from '../../_models/quota-item';
import { Stock } from '../../_models/stock';
import { Ship } from '../../_models/ship';

import { QuotaService } from '../../_services/quota.service';
import { StockService } from '../../_services/stock.service';
import { ShipService } from '../../_services/ship.service';

@Component({
  selector: 'app-quota-new-form',
  templateUrl: './quota-new-form.component.html',
  styleUrls: ['./quota-new-form.component.sass'],
})
export class QuotaNewFormComponent extends Form implements OnInit {
  // Component attributes
  form: FormGroup;
  quota: QuotaItem;
  stocks: Stock[] = [];
  ships: Ship[] = [];
  years: string[] = QuotaItem.getYears();
  year = new Date().getFullYear();
  quotaTypes: ChoicesModel[] = [];

  protected selectedShip: Ship = new Ship();
  protected selectedShips: Ship[] = [];

  constructor(
    private fb: FormBuilder,
    private quotaService: QuotaService,
    private stockService: StockService,
    private shipService: ShipService,
    protected route: ActivatedRoute,
    protected router: Router,
    protected httpErrorHandler: HttpErrorHandler
  ) {
    super(route, httpErrorHandler);
    this.form = fb.group({
      quota_type: '',
      stock: '',
      year: '',
      name: '',
      ships: '',
      amount: 0,
    });
  }

  ngOnInit() {
    this.quota = new QuotaItem({ year: this.years[0] });
    this.getStocks();
    this.getShips();
    this.getQuotaTypes();
    this.setFormMode('create');
  }

  getQuotaTypes() {
    this.quotaService.getOptions().subscribe(
      (data) => {
        this.quotaTypes = ChoicesModel.generateCollectionFromApi(data['actions']['POST']['quota_type']['choices']);
        // initialize default quota type
        this.quota.quota_type = 'individual';
      },
      (error) => this.handleError(error)
    );
  }

  getStocks() {
    this.stockService.list(1, 10000, '', '').subscribe(
      (response) => {
        this.stocks = this.parseDropdownResults(response.results, new Stock(), 'full_name');
      },
      (error) => this.httpErrorHandler.handleHttpError(error)
    );
  }

  getShips() {
    this.shipService.list(1, 10000, '', '').subscribe(
      (response) => {
        this.ships = this.parseDropdownResults(response.results, new Stock(), 'name', true);
      },
      (error) => this.httpErrorHandler.handleHttpError(error)
    );
  }

  handleError(error) {
    const errors = this.httpErrorHandler.handleHttpError(error);
    this.parseApiErrors(errors, this.form);
  }

  onSubmit() {
    this.form.reset();
    this.resetNonFieldErrors();
    this.createQuota();
  }

  createQuota() {
    if (this.quota.quota_type === 'individual') {
      this.quota.ships = [this.selectedShip];
    }

    if (this.quota.quota_type === 'multiple') {
      this.quota.ships = this.selectedShips;
    }

    this.quotaService.create(this.quota.serialize()).subscribe(
      (quota) => this.onCreate(quota),
      (error) => this.handleError(error)
    );
  }

  onCreate(quota) {
    this.router.navigate(['quotas-aggregated']);
  }
}



// WEBPACK FOOTER //
// ./src/app/quotas/quota-new-form/quota-new-form.component.ts